import axiosInstance from '../../../axios-config';

const postPatientInviteResponseValidationUrl = '/api/patients/signup/invitedPatientValidation';
const getVerificationFieldsUrl = '/api/patients/signup/verificationFields';

export const postPatientInviteResponseValidation = (firstName, lastName, birthDate, pin, mrn, ssn) =>
  axiosInstance.post(postPatientInviteResponseValidationUrl,
    {
      firstName,
      lastName,
      birthDate,
      pin,
      mrn,
      ssn,
    },
    { headers: { 'Content-Type': 'application/json' } }
  );

export const getVerificationFields = () => axiosInstance.get(getVerificationFieldsUrl);
